module.exports = __webpack_public_path__ + "static/media/notificationManagement.84a598b2.png";